import React, { useState, useEffect } from "react";
import './CommonCSS.css';
import { BASE_URL } from './apiConfig';
import { RotateSpinner } from "react-spinners-kit";

export default function DownloadCenter() {
    const [SummaryapiData, setSummaryApiData] = useState([]);
    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;
    const [showprogress, setshowprogress] = useState(false);

    const downloadurl = BASE_URL + "/Download/";
    const callApi = async () => {
        setshowprogress(true);
        const apiUrl = `${BASE_URL}/DownloadTable`;
        const requestBody = {
            Haslimit: "All",
            guiuserid: sessionusername,
            utype:{
                usertype:sessionusertype
            }
        };
        const fetchOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },

            body: JSON.stringify(requestBody),
        };

        try {
            const response = await fetch(apiUrl, fetchOptions);
            setshowprogress(false);
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            const data = await response.json();
            console.log(data);
            setSummaryApiData(data);
            // Callback to the parent component
        } catch (error) {
            console.error("API Request Error:", error.message);
        }
    };
    const apiDataLength = SummaryapiData?.length;
    useEffect(() => {
        callApi();

    }, []);
    return (
        <div className="maincontent-outermost">
            <div className="div-container" style={{ position: "relative" }}>
                <div className="row-container">
                    <span>Download Request Center</span>
                </div>

                <div className="row-container table-responsive mt-2" style={{ position: "relative" }}>
                    {showprogress === true ? <div className="spinner-overlay">
                                <div className="custom-spinner"></div>
                            </div> : <div></div>}

                    <table className={showprogress === true ? "table table-bordered mt-4 blurred" : "table table-bordered mt-4"} style={{ fontSize: "0.92rem" }}>
                        <thead style={{ backgroundColor: "skyblue" }}>
                            <tr>
                                <th>Request Date</th>
                                <th>Filename</th>
                                <th>Requested By</th>
                                <th>File Status</th>
                                <th>Download URL</th>
                            </tr>
                        </thead>
                        {apiDataLength === 0 ? (
                            <tbody>
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center", padding: "4rem 0" }}>
                                        <div className="img-report-div" style={{ width: "100%" }}>
                                            <div className="img-div">
                                                <img
                                                    src="images/NoReport.png"
                                                    className="img-noreport"
                                                    alt="No Report"
                                                    style={{ maxWidth: "200px" }}
                                                />
                                            </div>
                                            <p style={{ marginTop: "1rem", color: "grey" }}>
                                                No Downloads Found !!!
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {SummaryapiData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.reqDate}</td>
                                        <td>{item.fname}</td>
                                        <td>{item.reqBy}</td>
                                        <td style={{ display: "flex", justifyContent: "center" }}><span
                                            className={
                                                item?.fstatus === "In-Progress"
                                                    ? "Pending"
                                                    : item?.fstatus === "Rejected"
                                                    ? "Rejected"
                                                    : "Success"
                                            }
                                            style={{ marginTop: "-0.01rem", fontSize: "0.9rem", paddingLeft: "0.5rem", paddingRight: "0.5rem" }}
                                        >
                                            {item?.fstatus}
                                        </span></td>
                                        <td>
  {item?.fstatus === "Completed" ? (
    <>
      {item?.durl?.length > 25 ? (
        `${item?.durl?.substring(0, 25)}...`
      ) : (
        item?.durl
      )}
      <span style={{ marginLeft: '5.6px' }}>
        <a href={downloadurl + item?.durl} style={{ color: "black" }}>
          <i className="fa fa-download"></i>
        </a>
      </span>
    </>
  ) : (
    <span>

    </span>
  )}
</td>



                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>

                </div>
            </div>
        </div>
    );
}
